import * as XLSX from 'xlsx';

import { applyWrapText } from './xlsxWrapText';

/** MIME de un .xlsx. Es el que decide qué app ofrece Android al abrirlo. */
export const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/**
 * Convierte un libro de trabajo en un `Blob` descargable.
 *
 * Existe porque `XLSX.writeFile()` **descarga por su cuenta**: monta el ancla y
 * la pincha por dentro de la librería. En el navegador funciona, pero dentro
 * del APK no hace nada —el WebView no interpreta las URL `blob:`— y, al estar
 * escondido en la librería, ni siquiera pasaba por nuestro código: era un
 * segundo camino de descarga, invisible y roto.
 *
 * Con esto hay un solo camino: aquí se genera el contenido, y quien entrega el
 * fichero es siempre `saveBlob`.
 */
export async function toXlsxBlob(
  workbook: XLSX.WorkBook,
  /**
   * Columnas (0 = la primera) que hay que dejar con «Ajustar texto» porque su
   * contenido trae varias líneas. Sin esto Excel pinta el salto embebido en una
   * sola línea — ver `xlsxWrapText`, que explica por qué no basta con pedirle el
   * estilo a SheetJS.
   */
  wrapColumns: number[] = []
): Promise<Blob> {
  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const bytes = await applyWrapText(buffer, { columns: wrapColumns });
  return new Blob([bytes as BlobPart], { type: XLSX_MIME });
}

export default toXlsxBlob;
